import { IModule, IModuleBuilder } from "app/IModule";
import React from "react";

export default class AccountsModule implements IModule {
  build(builder: IModuleBuilder) {
    builder.addRoute("/accounts", React.lazy(() => import("./Accounts.page")));
  }
}